<template>
  <v-checkbox
    :id="`form-checkbox-${tag.name}`"
    v-model="formData"
    inset
    false-value="0"
    true-value="1"
    class="pt-0 mt-0 mb-4"
    :readonly="readonly"
    :label="tag.description"
    hide-details
  />
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
